// Recovered compiled webpack factory 15651. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  a.d(t, { NB: () => f, Y6: () => x, gv: () => n, q5: () => i });
  var r = a(32319);
  let n = "yearly";
  function i(e) {
    return "monthly" === e || "yearly" === e;
  }
  function s(e) {
    return Number.isInteger(e) ? `$${e}` : `$${e.toFixed(2)}`;
  }
  let o = {
      monthly: (0, r.nw)("monthly", "live").amountCents / 100,
      yearly: (0, r.nw)("yearly", "live").amountCents / 100,
    },
    l = 12 * o.monthly,
    c = Math.round((o.yearly / 12) * 100) / 100,
    d = Math.round((1 - o.yearly / l) * 100),
    m = Math.round((l - o.yearly) / o.monthly),
    u = s(o.monthly),
    h = s(o.yearly),
    p = s(c),
    f = {
      monthly: {
        display: `${u}/mo`,
        cadenceLabel: "Monthly",
        priceMain: `${u}/mo`,
        priceNote: "billed monthly",
        checkoutLabel: `${u}/month`,
        blurb: "Cancel anytime.",
      },
      yearly: {
        display: `${h}/yr`,
        cadenceLabel: "Yearly",
        priceMain: `${p}/mo`,
        priceNote: `${h} billed yearly \xb7 save ${d}%`,
        checkoutLabel: `${h}/year`,
        blurb: `Save ${d}% — ${m} months free.`,
      },
    },
    x = `${m} months free \xb7 ${d}% savings`;
  String(m);
}
